import { useMutation, useQueryClient } from "@tanstack/react-query";
import { SceneTemplate, SceneTemplateCreate } from "@/model";
import templateRepository from "@/repository/templateRepository";
import { templateKeys } from "./keys";


export const useCreateTemplate = (scenarioId: string) => {
    const queryClient = useQueryClient();

    return useMutation<SceneTemplate, Error, SceneTemplateCreate>({
        mutationFn: async (template: SceneTemplateCreate) => {
            const data = await templateRepository.create(scenarioId, template);
            return data.data!;
        },
        onSuccess: async () => {
            await queryClient.refetchQueries({ queryKey: templateKeys.all(scenarioId) });
        }
    });
};
